import Yup from '@fourthwall/utils/dist/yup'

export const validationSchema = Yup.object().shape({
  name: Yup.string().required().noHTML(),
  isTimeLimited: Yup.boolean(),
  isSoldOut: Yup.boolean(),
  sortingStrategy: Yup.string()
    .oneOf(['MANUAL', 'BEST_SELLING', 'NEWEST', 'OLDEST', 'NAME_ASC', 'NAME_DESC'])
    .required(),
  selectedProducts: Yup.array().of(Yup.string()),
  available: Yup.boolean(),
  startDate: Yup.date().when(['isTimeLimited', 'endDate'], (isTimeLimited, endDate) => {
    return isTimeLimited && !endDate ? Yup.date().required() : Yup.date()
  }),
  endDate: Yup.date(),
})
